import { useMemo } from 'react';
import { Entity } from '@backstage/catalog-model';
import { useApi, configApiRef } from '@backstage/core-plugin-api';

export const REPO_NOT_IMPLEMENTED = 'Not a Bitbucket repo';

const extractSonarProjectKey = (entity: Entity): string => {
  // We can extract the key from the source code annotations
  const repoUrl =
    entity?.metadata.annotations?.['backstage.io/source-location'] || '';
  if (repoUrl.indexOf('bitbucket.org') < 0) {
    return REPO_NOT_IMPLEMENTED;
  }

  const [org, repo] = repoUrl
    .replace('url:', '')
    .replace('https://bitbucket.org/', '')
    .split('/')
    .slice(0, 2);

  const repoSanitized = repo.replace('.', '-');

  return `${org}_${repoSanitized}`;
};

const useSonarQubeEntity = (entity: Entity) => {
  const config = useApi(configApiRef);
  const sonarConfig = config.getConfig('bidone.sonarqube');
  const baseUrl = sonarConfig.getString('baseUrl');

  const projectKey = useMemo(() => extractSonarProjectKey(entity), [entity]);
  const projectUrl = useMemo(() => {
    if (projectKey === REPO_NOT_IMPLEMENTED) {
      return '';
    }
    return `${baseUrl}/project/overview?id=${projectKey}`;
  }, [projectKey, baseUrl]);

  return { projectKey, projectUrl };
};

export { useSonarQubeEntity };
